import { FC, useState } from "react";
import { floatToPriceWithoutSpace } from "../../functions/price_functions";
import "./resumeCart.css";
import { BsChevronUp, BsChevronDown } from "react-icons/bs";
import { useDiscount } from "../../hooks/useDiscount";

type Props = {
  totalWithoutDiscount: number;
  total: number;
  deliveryTax: number;
};

const ResumeCart: FC<Props> = ({
  totalWithoutDiscount,
  total,
  deliveryTax,
}) => {
  const [isOpen, setIsOpen] = useState(true);
  const { data } = useDiscount();

  return (
    <div className="resumeCart">
      <div className="main">
        <h4>Resumo da Compra</h4>
        {isOpen ? (
          <BsChevronDown onClick={() => setIsOpen(false)} />
        ) : (
          <BsChevronUp onClick={() => setIsOpen(true)} />
        )}
      </div>
      {isOpen && (
        <>
          <div className="item-resume">
            <p>Valor dos Produtos</p>
            <p className="price">{floatToPriceWithoutSpace(total)}</p>
          </div>
          <div className="item-resume">
            <p>Desconto</p>
            <p className="price">
              {floatToPriceWithoutSpace(data.couponValue)}
            </p>
          </div>
          {/* <div className="item-resume">
            <p>Taxa</p>
            <p className="price">{floatToPriceWithoutSpace(deliveryTax)}</p>
          </div> */}
          <div className="item-total-resume">
            <p>Total da compra</p>
            <p className="price">
              {floatToPriceWithoutSpace(total - data.couponValue)}
            </p>
          </div>
        </>
      )}
    </div>
  );
};

export { ResumeCart };
